module.exports = __webpack_public_path__ + "img/m-icon-2.31422272.png";